import { AudioLines, CodeXml, ScanFace } from "lucide-react";
import { useTranslation } from "react-i18next";

/**
 * Voice Analysis Content Component
 * Displays the voice analysis visualization with gradient background
 */
export function VoiceAnalysisContent() {
  const { t } = useTranslation('marketing');

  return (
<div className="w-full aspect-[4/3] rounded-2xl bg-[linear-gradient(150deg,var(--color-light-red)_0%,var(--color-light-lin)_20%,var(--color-gradient-light)_70%,var(--color-gradient-purple)_100%)] relative overflow-hidden flex items-center justify-center">      {/* All analysis visualization image */}
{/* Voice visualization image */}
      <div className="flex items-center gap-1">
        <img src="/landing-img/illus-voice.png" alt={t('interview_tabs.voice.image_alt')} className="w-full max-w-sm md:max-w-md lg:max-w-full h-full object-cover" />
      </div>

      {/* Floating label with voice analysis indicator */}
      <div className="absolute bottom-16 lg:bottom-25 left-1/2 transform -translate-x-1/2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full border-2 border-white">
        <div className="flex items-center gap-2">
          <AudioLines className="w-5 h-5 text-white" />
          <span className="text-white text-sm font-medium">{t('interview_tabs.voice.badge')}</span>
        </div>
      </div>
    </div>
  );
}

/**
 * Face Analysis Content Component
 * Displays the face analysis visualization with gradient background
 */
export function FaceAnalysisContent() {
  const { t } = useTranslation('marketing');

  return (
<div className="w-full aspect-[4/3] rounded-2xl bg-[linear-gradient(150deg,var(--color-light-red)_0%,var(--color-light-lin)_20%,var(--color-gradient-light)_70%,var(--color-gradient-purple)_100%)] relative overflow-hidden flex items-center justify-center">      {/* All analysis visualization image */}
{/* Face visualization image */}
      <div className="flex items-center gap-1">
        <img src="/landing-img/illus-face.png" alt={t('interview_tabs.face.image_alt')} className="w-full max-w-sm md:max-w-md lg:max-w-full h-full object-cover" />
      </div>

      {/* Floating label with face analysis indicator */}
      <div className="absolute bottom-16 lg:bottom-30 left-1/3 lg:left-55 transform -translate-x-1/2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full border-2 border-white">
        <div className="flex items-center gap-2">
          <ScanFace className="w-5 h-5 text-white" />
          <span className="text-white text-sm font-medium">{t('interview_tabs.face.badge')}</span>
        </div>
      </div>
    </div>
  );
}

/**
 * Code Graph Content Component
 * Displays the code graph visualization with gradient background
 */
export function CodeGraphContent() {
  const { t } = useTranslation('marketing');

  return (
<div className="w-full aspect-[4/3] rounded-2xl bg-[linear-gradient(150deg,var(--color-light-red)_0%,var(--color-light-lin)_20%,var(--color-gradient-light)_70%,var(--color-gradient-purple)_100%)] relative overflow-hidden flex items-center justify-center">      {/* All analysis visualization image */}
{/* Code graph visualization image */}
      <div className="flex items-center gap-1">
        <img src="/landing-img/illus-code-graph.png" alt={t('interview_tabs.code.image_alt')} className="w-full max-w-sm md:max-w-md lg:max-w-xl h-full object-cover" />
      </div>

      {/* Floating label with code analysis indicator */}
      <div className="absolute bottom-16 lg:bottom-25 left-1/2 transform -translate-x-1/2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full border-2 border-white">
        <div className="flex items-center gap-2">
          <CodeXml className="w-5 h-5 text-white" />
          <span className="text-white text-sm font-medium">{t('interview_tabs.code.badge')}</span>
        </div>
      </div>
    </div>
  );
}

/**
 * All Analysis Content Component
 * Displays the all analysis visualization with gradient background
 */
export function AllAnalysisContent() {
  const { t } = useTranslation('marketing');

  return (
<div className="w-full aspect-[4/3] rounded-2xl bg-[linear-gradient(150deg,var(--color-light-red)_0%,var(--color-light-lin)_20%,var(--color-gradient-light)_70%,var(--color-gradient-purple)_100%)] relative overflow-hidden flex items-center justify-center">      {/* All analysis visualization image */}
      <div className="flex items-center gap-1">
        <img src="/landing-img/illus-analysis.png" alt={t('interview_tabs.all.image_alt')} className="w-full max-w-sm md:max-w-md lg:max-w-full h-full object-cover" />
      </div>
    </div>
  );
}
